<sirius-container>
    <ul>
        @for (author of authors; track $index) {
            <li>
                <sirius-author [config]="author"></sirius-author>
            </li>
        }
    </ul>
</sirius-container>
